import React, { useEffect, useState } from "react";
import { Table, Pagination, Spinner } from "react-bootstrap";
import onsite from "./../../../assets/Vector.svg";
import online from "./../../../assets/Online.svg";
import { useAppContext } from "../../../contexts/AppContext";
import LocationModal from "../LocationModal";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
const ViewSchedule = ({
  rescheduleLoading,
  scheduleData,
  rescheduleChange,
  unEnrollChange,
  selectedUser,
  onSortedDataChange,
  printActionTriggered,
  onPrintData,
  isUnEnrollClicked
}) => {

  const { currentUser } = useAppContext();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rescheduleLoadingRowId, setRescheduleLoadingRowId] = useState(null);
  const [unenrollLoadingRowId, setUnenrollLoadingRowId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [sortConfig, setSortConfig] = useState({
    key: "date",
    direction: "desc",
  });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const filteredData = Object.entries(scheduleData)
    .sort((a, b) => new Date(b[0]) - new Date(a[0]))
    .flatMap(([date, sessions]) =>
      sessions
        .sort((a, b) => new Date(b.date_start) - new Date(a.date_start))
        .map((session) => {
          const sessionDate = new Date(session.date_start);

          // Apply date filter
          const fromOk = fromDate ? sessionDate >= new Date(fromDate) : true;
          const toOk = toDate
            ? sessionDate <= new Date(toDate + "T23:59:59")
            : true;

          if (!fromOk || !toOk) return null;

          return {
            rawDate: session.date_start,
            rawEndDate: session.date_end,
            date: sessionDate.toLocaleDateString("en-US", {
              weekday: "short",
              month: "short",
              day: "numeric",
              year: "numeric",
            }),
            format:
              session.attendance_type === "online" ? "Webinar" : "In-Person",
            time: `${new Date(session.date_start).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })} – ${new Date(session.date_end).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}`,
            location: session.additional_fields.filter(x => x.id === "20") ?? session.additional_fields.filter(x => x.id === "20")[0].value != null ? session.additional_fields.filter(x => x.id === "20")[0].value : "",
            attendanceType: session.attendance_type,
            //session.location ? session.location.name : "Zoom Link",
            locationDetails: session.location,
            course: session.coursename,
            courseId: session.courseid,
            sessionId: session.id,
            classLanguage: session.additional_fields
              .filter((x) => x.id === "10")
              .map((x) => x.value),
            interpreterLanguage: session.additional_fields
              .filter((x) => x.id === "11")
              .map((x) => x.value),
            previousSession: session.name,
            roomname: session.attendance_type != "online" ? session.name?.split(" - ")?.[0] ?? "" : ""
          };
        }),
    )
    .filter(Boolean);

  const globallySortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];

      if (sortConfig.key === "date") {
        aVal = new Date(a.rawDate);
        bVal = new Date(b.rawDate);
      }

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = globallySortedData.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const sortedData = [...currentItems].sort((a, b) => {
    if (sortConfig.key) {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];
      if (sortConfig.key === "date") {
        aVal = new Date(a.rawDate);
        bVal = new Date(b.rawDate);
      }

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const onCourseNavigation = (
    selectedCourseName,
    selectedCourseId,
    selectedSessionId,
  ) => {
    setLoading(false);
    window.open(
      `${process.env.REACT_APP_VIEW_COURSES_PAGE_URL}/courses/${selectedCourseId}/${selectedCourseName.replace(/[()]/g, '')}/sessions/${selectedSessionId}/${selectedCourseName.replace(/[()]/g, '')}`,
      "_blank",
    );
    //  window.top.location.href = `https://seiu775bgsandbox1.docebosaas.com/learn/courses/${selectedCourseId}/${selectedCourseName}/sessions/${selectedSessionId}/${selectedCourseName}`;
  };

  useEffect(() => {
    if (printActionTriggered && onPrintData) {
      onPrintData(filteredData);
    }
  }, [printActionTriggered, filteredData, onPrintData]);

  return (
    <div className="view_schedule_container">
      <div className="view_schedule_details_and_filter">
        {currentUser?.isPowerUser ? (
          <div className="view_schedule_learner_details">
            <div>
              <span>Student Id: </span>
              <span>
                {currentUser?.isPowerUser
                  ? selectedUser?.username
                  : currentUser.user_id}
              </span>
            </div>
            <div>
              <span>Student Name: </span>
              <span>
                {currentUser?.isPowerUser
                  ? selectedUser?.firstname + " " + selectedUser?.lastname
                  : currentUser?.first_name + " " + currentUser?.last_name}
              </span>
            </div>
          </div>
        ) : (
          <div className="view_schedule_learner_details"></div>
        )}

        <div className="view_schedule_date_filters_container">
          <div className="view_schedule_date_filters">
            <div style={{ width: "30px" }}>
              <CustomTooltip text="Reset" placement="top">
                <button
                  style={{ border: "none" }}
                  onClick={() => {
                    setFromDate("");
                    setToDate("");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M5.463 4.433A9.96 9.96 0 0 1 12 2c5.523 0 10 4.477 10 10c0 2.136-.67 4.116-1.81 5.74L17 12h3A8 8 0 0 0 6.46 6.228zm13.074 15.134A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.136.67-4.116 1.81-5.74L7 12H4a8 8 0 0 0 13.54 5.772z"
                    ></path>
                  </svg>
                </button>
              </CustomTooltip>
            </div>
            <div>
              <span>from: </span>
              <input
                style={{
                  border: "solid 1px #E2E5E9",
                  padding: "2px",
                  cursor: "pointer",
                }}
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div>
              <span>to: </span>
              <input
                style={{
                  border: "solid 1px #E2E5E9",
                  padding: "2px",
                  cursor: "pointer",
                }}
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                min={fromDate}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="view_schedule_table_data">
        <Table bordered={false} borderless responsive>
          <thead
            style={{
              borderTop: "solid 1px #E2E5E9",
              borderBottom: "solid 1px #E2E5E9",
            }}
          >
            <tr>
              <th
                onClick={() => handleSort("date")}
                style={{ cursor: "pointer" }}
              >
                DATE{" "}
                <span style={{ fontSize: "10px" }}>
                  <span
                    style={{
                      color:
                        sortConfig.key === "date" &&
                          sortConfig.direction === "asc"
                          ? "black"
                          : "#ccc",
                    }}
                  >
                    ↑
                  </span>
                  <span
                    style={{
                      color:
                        sortConfig.key === "date" &&
                          sortConfig.direction === "desc"
                          ? "black"
                          : "#ccc",
                    }}
                  >
                    ↓
                  </span>
                </span>
              </th>
              <th style={{ width: currentUser.isPowerUser ? "12%" : "12%" }}>
                FORMAT
              </th>
              <th>TIME</th>
              <th style={{ width: currentUser.isPowerUser ? "18%" : "18%" }}>
                LOCATION
              </th>
              <th
                onClick={() => handleSort("course")}
                style={{ cursor: "pointer" }}
              >
                COURSE{" "}
                <span style={{ fontSize: "10px" }}>
                  <span
                    style={{
                      color:
                        sortConfig.key === "course" &&
                          sortConfig.direction === "asc"
                          ? "black"
                          : "#ccc",
                    }}
                  >
                    ↑
                  </span>
                  <span
                    style={{
                      color:
                        sortConfig.key === "course" &&
                          sortConfig.direction === "desc"
                          ? "black"
                          : "#ccc",
                    }}
                  >
                    ↓
                  </span>
                </span>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sortedData && sortedData.length > 0 ? (
              sortedData.map((row, idx) => (
                <tr className="date-header" key={idx}>
                  <td>{row.date}</td>
                  <td>
                    <div className="view_schedule_format">
                      {row.format === "Webinar" ? (
                        <img
                          src={onsite}
                          style={{
                            width: "16px",
                            marginBottom: "4px",
                            marginRight: "2px",
                          }}
                          alt="Webinar"
                        />
                      ) : (
                        <img
                          src={online}
                          style={{
                            width: "14px",
                            marginBottom: "5px",
                            marginRight: "2px",
                          }}
                          alt="In-Person"
                        />
                      )}
                      <span style={{ fontWeight: "normal" }}>{row.format}</span>
                    </div>
                  </td>
                  <td>
                    <span style={{ fontWeight: "normal" }}>{row.time}</span>
                  </td>
                  {row.attendanceType === "online" ? (<td
                    title={row.location || ""}
                    style={{
                      color: row.location ? "blue" : "blue",
                      textDecoration: row.location ? "underline" : "none",
                      cursor: row.location ? "pointer" : "not-allowed",
                      pointerEvents: row.location ? "auto" : "none", // disables mouse click
                    }}
                    tabIndex={row.location ? 0 : -1} // remove focus if no link
                    onKeyDown={(e) => {
                      if (!row.location) return;

                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setSelectedLocation(row.locationDetails);
                        window.open(row.location, "_blank");
                      }
                    }}
                    onClick={() => {
                      if (!row.location) return;

                      setSelectedLocation(row.locationDetails);
                      window.open(row.location, "_blank");
                    }}
                  >
                    Webinar - located in the Caregiver Learning Center.
                  </td>) : (<td

                  // tabIndex={0}
                  // onKeyDown={(e) => {
                  // support Enter/Space activation
                  //     if (e.key === "Enter" || e.key === " ") {
                  //   e.preventDefault();
                  //  setSelectedLocation(row.locationDetails);
                  // if (row.location !== "Zoom Link") {
                  //    setShowLocationModal(true);
                  // }
                  //  }
                  // }}
                  // onClick={() => {
                  //  setSelectedLocation(row.locationDetails);
                  // if (row.location !== "Zoom Link") {
                  //  setShowLocationModal(true);
                  // }
                  //  }}
                  >
                    <div
                    //  style={{
                    // color: "blue",
                    // textDecoration: "underline",
                    // cursor: "pointer",
                    //       }}
                    >{row.location}</div>
                    {
                      row?.roomname != ""
                        ? row?.roomname + " Room"
                        : ""
                    }
                  </td>)
                  }

                  <td>{row.course}</td>

                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <button
                        className="small_button"
                        style={{
                          minWidth: "50px",
                        }}
                        onClick={() => {
                          rescheduleChange(row);
                          setRescheduleLoadingRowId(row.sessionId);
                        }}
                      >
                        {rescheduleLoadingRowId === row.sessionId && (
                          <Spinner
                            className="me-1"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Reschedule
                      </button>
                      <button
                        style={{
                          minWidth: "50px",
                        }}
                        className="small_button"
                        onClick={() => {
                          unEnrollChange(row);
                          setUnenrollLoadingRowId(row.sessionId);
                        }}
                      >
                        {unenrollLoadingRowId === row.sessionId && isUnEnrollClicked === true && (
                          <Spinner
                            className="me-1"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Unenroll
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "center",
                    padding: "10px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      textAlign: "center",
                      padding: "10px",
                      height: "30vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    No records found
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="view_schedule_table_footer">
        <div className="view_schedule_table_records_counts">
          <div className="total_records">
            <span>Total Records: </span>
            <span>{filteredData.length}</span>
          </div>

          <div className="page_size">
            <span>Page Size:</span>
            <select
              value={itemsPerPage}
              id="selectpagesize"

              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              style={{
                minWidth: "50px",
                height: "24px",
                border: "1px solid #E2E5E9",
                borderRadius: "4px",
                padding: "0px",
                textAlign: "center",
                outline: "none",
              }}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>

        <div className="view_schedule_table_pagination_container">
          <Pagination className="custom-pagination">
            <Pagination.First onClick={() => goToPage(1)} />
            <Pagination.Prev onClick={() => goToPage(currentPage - 1)} />

            {currentPage > 1 && (
              <Pagination.Item onClick={() => goToPage(currentPage - 1)}>
                {currentPage - 1}
              </Pagination.Item>
            )}

            <Pagination.Item active>{currentPage}</Pagination.Item>

            {currentPage < totalPages && (
              <Pagination.Item onClick={() => goToPage(currentPage + 1)}>
                {currentPage + 1}
              </Pagination.Item>
            )}

            <Pagination.Next onClick={() => goToPage(currentPage + 1)} />
            <Pagination.Last onClick={() => goToPage(totalPages)} />
          </Pagination>
        </div>
      </div>
      <LocationModal
        isOpen={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        location={selectedLocation}
      />
      {loading && (
        <div className="courseLink_loader-overlay">
          <div className="loader-container">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewSchedule;
